// export default function Logo({ size = 32 }) {
//   return (
//     <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
//       {/* Outer circle */}
//       <circle cx="50" cy="50" r="48" fill="currentColor" opacity="0.1" />
//
//       {/* Keyhole body - horizontal oval */}
//       <ellipse cx="50" cy="50" rx="28" ry="16" fill="currentColor" />
//
//       {/* Keyhole slot - horizontal rectangle */}
//       <rect x="52" y="42" width="20" height="16" rx="2" fill="var(--bg-primary)" />
//
//       {/* Eye dots for face impression */}
//       <circle cx="35" cy="46" r="3" fill="var(--bg-primary)" />
//       <circle cx="35" cy="54" r="3" fill="var(--bg-primary)" />
//
//       {/* Smile curve (optional - cute factor) */}
//       <path
//         d="M 30 50 Q 35 55, 40 50"
//         stroke="var(--bg-primary)"
//         strokeWidth="2"
//         fill="none"
//         strokeLinecap="round"
//       />
//     </svg>
//   );
// }
export default function Logo({ size = 32 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="AI bot keyhole logo"
    >
      <circle cx="128" cy="128" r="128" fill="currentColor" stroke="none" />
      <ellipse cx="86" cy="128" rx="36" ry="32" fill="#000000" />
      <rect x="91" y="117" width="86" height="22" rx="14" fill="#000000" />
      <rect x="148" y="100" width="60" height="55" rx="10" fill="#000000" />
    </svg>
  );
}
